
export const CROPS = [
  {
    key: 'grape-green',
    name: 'العنب الأخضر',
    en: 'Green Grape',
    img: 'crop-grape-green.webp',
    accent: '#c3eb03',
    desc: {
      ar: 'أصنافٌ فاخرة من العنب الأخضر عديم البذور تُزرَع على تكاعيب مزارع المجموعة بالصعيد و مدينة السادات، وتُقطَف وتُعبَّأ يدويًا طازجةً للسوق المحلي والتصدير.',
      en: 'Premium seedless green grape varieties grown on the trellises of our Upper Egypt farms, hand-picked and hand-packed fresh for both the domestic market and export.',
    },
  },
  {
    key: 'grape-red',
    name: 'العنب الأحمر',
    en: 'Red Grape',
    img: 'crop-grape-red.webp',
    accent: '#e56c8e',
    desc: {
      ar: 'عنبٌ أحمر داكن وفير العناقيد بحلاوةٍ متوازنة، يُنتَج بأساليب ريٍّ حديثة ثم يُفرَز ويُعبَّأ في عبواتٍ تصديرية بأعلى معايير الجودة.',
      en: 'Deep red, full-bunched grapes with a balanced sweetness, grown with modern irrigation techniques then graded and packed in export-grade cases to the highest quality standards.',
    },
  },
  {
    key: 'grape-black',
    name: 'العنب الأسود',
    en: 'Black Grape',
    img: '004050ac08c2fb0310524861f3256f75.webp',
    accent: '#5b2a86',
    desc: {
      ar: 'عنبٌ أسود داكن العناقيد بقشرةٍ لامعة ونكهةٍ غنية، يُزرَع في مزارع المجموعة ويُقطَف ويُعبَّأ طازجًا للسوق المحلي والتصدير.',
      en: 'Deep-dark black grapes with a glossy skin and rich flavour, grown on the group’s Upper Egypt farms and hand-picked and packed fresh for the local market and export.',
    },
  },
  {
    key: 'mango',
    name: 'المانجو',
    en: 'Mango',
    img: 'crop-mango.webp',
    accent: '#f5ae27',
    desc: {
      ar: 'أجود أصناف المانجو المصرية الغنية بالنكهة، تنضج تحت شمس بلدنا الدافئة وتربتها الغنية لتصل إلى الأسواق بلونٍ ذهبيٍّ ومذاقٍ مميّز.',
      en: 'The finest varieties of Egyptian mangoes, rich in flavor, ripen under the warm sun of our country and its fertile soil, reaching the markets with a golden color and a distinctive taste.',
    },
  },
  {
    key: 'pomegranate',
    name: 'الرمان',
    en: 'Pomegranate',
    img: 'crop-pomegranate.webp',
    accent: '#92222b',
    desc: {
      ar: 'استثمار زراعي ممتد، ننتج ثماراً حمراء ناضجة، غنية بمضادات الأكسدة، وتتميز بمواصفات قياسية تجعلها الخيار الأمثل لرمان المائدة و لأغراض العصر والتصدير للأسواق العالمية.',
      en: 'Through extensive agricultural investments, we produce ripe red fruits rich in antioxidants, characterized by standard specifications that make them the ideal choice for table pomegranates and for juicing and exporting to global markets.',
    },
  },
  {
    key: 'Citrus & vegetables',
    name: 'موالح وخضروات',
    en: 'Citrus & vegetables',
    img: 'crop-orange.webp',
    accent: '#ffe931',
    desc: {
      ar: 'تختار المجموعة أفضل أنواع الموالح، إضافة إلى البطاطا الحلوة والخضروات الطازجة، وتعبئها وفق معايير جودة عالمية لضمان وصولها للأسواق الخارجية بأعلى جودة.',
      en: 'The group selects the best types of citrus fruits, in addition to sweet potatoes and fresh vegetables, and packages them according to global quality standards to ensure they reach foreign markets with the highest quality.',
    },
  },

];

export const PACKING = {
  eyebrow: { ar: 'التعبئة والتصدير', en: 'Packing & Export' },
  title: {
    before: { ar: 'نُعبّئ ونُصدّر ', en: 'We Pack & Export ' },
    bold: { ar: 'باحترافية', en: 'with Expertise' },
  },
  lead: {
    ar: 'من الحقل إلى رفوف الأسواق — نفرز محاصيلنا ونُعبّئها ونزنها ونشحنها وفق أعلى معايير الجودة، ونُصدّرها كمنتجٍ مصري تحت علامة «الهواري جروب — خضروات وفواكه».',
    en: 'From the field to the market shelf — we grade, pack, weigh and ship our crops to the highest quality standards, exporting them as a Produce of Egypt under the "Elhaware Group — Vegetables & Fruits" brand.',
  },
  photos: [
    {
      img: 'pack-export-box.webp',
      cap: {
        ar: 'عبوات التصدير المعتمدة تحت علامة «الهواري جروب» — منتج مصري (Produce of Egypt)',
        en: 'Certified export packaging under the "Elhaware Group" brand — a Produce of Egypt',
      },
      wide: true,
    },
    {
      img: 'pack-grapes.webp',
      cap: {
        ar: 'فرز العنب وتعبئته في عبواتٍ تصديرية مُحكمة',
        en: 'Grading and packing grapes into secure export-grade cases',
      },
    },
    {
      img: 'pack-weighing.webp',
      cap: {
        ar: 'وزن المحصول ومعايرته على موازين دقيقة قبل الشحن',
        en: 'Weighing and calibrating the harvest on precision scales before shipping',
      },
    },
    {
      img: 'pack-field-record.webp',
      cap: {
        ar: 'إدارة مزرعية موثّقة: الصنف والمساحة وتاريخ الزراعة لكل قطاع',
        en: 'Documented farm management: variety, area and planting date for every plot',
      },
    },
  ],
};

export const MOLASSES = {
  img: 'Pngtreejar_of_molasses_with_thick_15923562.webp',
  overlayImg: 'image.webp',
  eyebrow: { ar: 'منتج مميّز', en: 'Signature Product' },
  title: {
    before: { ar: 'المولاس — ', en: 'Molasses — ' },
    bold: { ar: 'العسل الأسود المحوّل الصناعي', en: 'Converted Black Honey' },
  },
  lead: {
    ar: "المولاس (العسل الأسود) منتجٌ ثانويٌّ لزجٌ عالي القيمة يُستخلَص من تكرير عصير قصب السكر؛ ومجموعة الهواري هي أكبر منتجٍ للعسل الأسود المحوّل الصناعي في مصر وواجهة صناعته في نجع حمادي.",
    en: 'Molasses (black honey) is a high-value, viscous by-product extracted from refining sugarcane juice. Elhaware Group is the largest producer of converted molasses in Egypt and the leading name in the industry in Nag Hammadi.',
  },
  facts: [
    {
      ar: 'إضافةٌ رئيسية لأعلاف المواشي والدواجن لرفع طاقتها الغذائية.',
      en: 'A key additive in cattle and poultry animal feed to boost its nutritional energy.',
    },
    {
      ar: 'يدخل في التخمير وإنتاج الكحول والخمائر ومحسّنات التربة.',
      en: 'Used in fermentation and in producing alcohol, yeast and soil conditioners.',
    },
    {
      ar: 'مدخل أساسي لمصانع الدخان والمعسل في مصر',
      en: "A primary input for tobacco and shisha (mu'assel) factories in Egypt.",
    },
    {
      ar: 'غنيٌّ بالحديد والكالسيوم والماغنيسيوم والبوتاسيوم والمنغنيز.',
      en: 'Rich in iron, calcium, magnesium, potassium and manganese.',
    },
  ],
  badge: {
    big: '#1',
    text: {
      ar: 'أكبر منتج للعسل الأسود المحوّل الصناعي في مصر',
      en: 'The largest producer of industrially processed molasses in Egypt.',
    },
  },
  source: 'https://en.wikipedia.org/wiki/Molasses',
  sourceLabel: { ar: 'المصدر: ويكيبيديا', en: 'Source: Wikipedia' },
};
